import React, { useState } from "react";
import { AppBar, Toolbar, Button, Box, Menu, MenuItem, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAuth } from "../context/AuthContext.tsx";

const Navbar = () => {
  const { user, logout } = useAuth(); // ✅ Get user & logout function from context
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await logout();
    navigate("/signin"); // ✅ Redirect after logout
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: "white", px: 2, boxShadow: 3 }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Jasel Logo on the Left */}
        <Box>
          <Link to="/">
            <img
              src="https://jaseljewelry.com/cdn/shop/files/Jasel_logo_png.jpg?v=1687231797&width=600"
              alt="Jasel Logo"
              style={{ height: "50px" }}
            />
          </Link>
        </Box>

        {/* Right Side Buttons */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {/* Consent Dropdown */}
          <Box>
            <Button
              color="inherit"
              endIcon={<ArrowDropDownIcon />}
              onClick={(event) => setAnchorEl(event.currentTarget)}
              sx={{ color: "black", fontWeight: "bold" }}
            >
              Consent
            </Button>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
              <MenuItem component={Link} to="/consent" onClick={() => setAnchorEl(null)}>
                Piercing Consent
              </MenuItem>
              <MenuItem component={Link} to="/under18consent" onClick={() => setAnchorEl(null)}>
                Under 18 Consent
              </MenuItem>
              <MenuItem component={Link} to="/body-piercing-record" onClick={() => setAnchorEl(null)}>
                Body Piercing Record
              </MenuItem>
              <MenuItem component={Link} to="/tattoo-consent" onClick={() => setAnchorEl(null)}>
                Tattoo Consent
              </MenuItem>
            </Menu>
          </Box>

          {/* Show "Customer" Tab Only When Logged In */}
          {user && (
            <Button
              component={Link}
              to="/customer"
              variant="outlined"
              sx={{ borderColor: "black", color: "black", fontWeight: "bold" }}
            >
              Customers
            </Button>
          )}

          {/* User Sign-In / Sign-Out Section */}
          {user ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: "bold", color: "black" }}>
                Welcome, {user}
              </Typography>
              <Button onClick={handleSignOut} variant="outlined" sx={{ borderColor: "black", color: "black", fontWeight: "bold" }}>
                Sign Out
              </Button>
            </Box>
          ) : (
            <Button component={Link} to="/signin" variant="outlined" sx={{ borderColor: "black", color: "black", fontWeight: "bold" }}>
              Sign In
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
